import styled from 'styled-components';

// @ts-ignore
import * as Base from './styled.ts';

export const ActionContainer = styled(Base.ActionContainer)`
  justify-content: space-between;
  align-items: center;

  > :last-child {
    margin-left: 0.6875rem;
  }
`;

export const AddressSubheader = styled(Base.AddressSubheader)`
  display: flex;
  flex: 1 1 auto;
  flex-direction: row;
  justify-content: space-between;
  max-width: 100%;

  p {
    flex: 1;
  }

  a {
    flex: 0 1;
    align-self: flex-end;
    white-space: nowrap;
  }
`;

export const AddressHeader = styled(Base.AddressHeader)`
  h2,
  p {
    font-size: 1rem;
    text-transform: none;

    ${Styles.desktop`
      font-size: 1.125rem;
    `}
  }

  h2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 75%;
    margin: 8px 0;
    font-size: 1.5rem;
  }

  p {
    margin: 8px 0;
  }
`;

export const Divider = styled.div`
  background-color: ${Styles.color.black};
  height: 1px;
  margin: 0.75rem auto 1rem auto;
  opacity: 0.1;
  width: 100%;
`;

export const MoreInfoLink = styled.a`
  color: ${Styles.color.black};
  font-size: 0.875rem;
  letter-spacing: normal;
  line-height: 1;
  text-decoration: underline;
`;

export const StoreCardContainer = styled(Base.StoreCardContainer)`
  background: ${Styles.color.white};
  padding: 1rem 1.125rem;
  overflow: hidden;
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${Styles.desktop`
    width: 100%;
    margin-bottom: 0.5rem;
  `}
`;

export const SubheaderContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  p {
    font-size: 0.75rem;
  }
`;

export const TimeNoteWrapper = styled(Base.TimeNoteWrapper)`
  display: block;
  margin-bottom: 0;
  p {
    margin: 0;
  }
`;

export const AvailableServiceModesText = styled.p`
  padding-right: 0.75rem;
`;

// @ts-ignore
export * from './styled.ts';
